export const fmtMYR = (n) =>
  new Intl.NumberFormat("en-MY", { style: "currency", currency: "MYR", maximumFractionDigits: 2 }).format(Number(n || 0));

export const fmtL = (n) =>
  `${new Intl.NumberFormat("en-MY", { maximumFractionDigits: 1 }).format(Number(n || 0))} L`;

export const fmtNum = (n) =>
  new Intl.NumberFormat("en-MY", { maximumFractionDigits: 2 }).format(Number(n || 0));

export const fmtDate = (s) => {
  if (!s) return "—";
  const str = String(s);
  if (str.length >= 10 && str[4] === "-" && str[7] === "-")
    return `${str.slice(8, 10)}/${str.slice(5, 7)}/${str.slice(0, 4)}`;
  return str;
};

export const todayStr = () => new Date().toISOString().slice(0, 10);
export const monthStr = () => new Date().toISOString().slice(0, 7);

export const PRODUCT_COLORS = {
  RON95: "#059669",
  DIESEL: "#D97706",
  EURO5: "#2563EB",
};

export const PRODUCT_OPTIONS = [
  { value: "RON95", label: "RON95" },
  { value: "DIESEL", label: "DIESEL" },
  { value: "EURO5", label: "Euro 5 (B7)" },
];

export const PRODUCT_LABELS = { RON95: "RON95", DIESEL: "DIESEL", EURO5: "Euro 5 (B7)" };
export const prodLabel = (p) => PRODUCT_LABELS[p] || p;
